import { getGetterTypesForService } from 'shared/utils/createServiceStore.js';
import { USER_SERVICE_KEY } from './userEnum.js';

export default getGetterTypesForService(USER_SERVICE_KEY);
